import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import BookFitting from "@/pages/BookFitting";
import TrackOrder from "@/pages/TrackOrder";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LeaveReview from "@/pages/LeaveReview";
import DryCleaningPickup from "@/pages/DryCleaningPickup";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminBookings from "@/pages/AdminBookings";
import AdminPromotions from "@/pages/AdminPromotions";
import AdminReviews from "@/pages/AdminReviews";
import AdminContent from "@/pages/AdminContent";
import AdminBusiness from "@/pages/AdminBusiness";
import AdminQR from "@/pages/AdminQR";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/book" element={<BookFitting/>}/>
            <Route path="/track" element={<TrackOrder/>}/>
            <Route path="/review/:code" element={<LeaveReview/>}/>
            <Route path="/pickup" element={<DryCleaningPickup/>}/>
            <Route path="/payment/success" element={<PaymentSuccess/>}/>
            <Route path="/payment/cancel" element={<PaymentCancel/>}/>
            <Route path="/admin" element={<AdminLogin/>}/>
            <Route path="/admin/*" element={<AdminLayout/>}>
              <Route path="bookings" element={<AdminBookings/>}/>
              <Route path="promotions" element={<AdminPromotions/>}/>
              <Route path="reviews" element={<AdminReviews/>}/>
              <Route path="content" element={<AdminContent/>}/>
              <Route path="business" element={<AdminBusiness/>}/>
              <Route path="qr" element={<AdminQR/>}/>
            </Route>
          </Routes>
          <Footer/>
          <InstallPrompt/>
          <Toaster position="top-center" richColors closeButton/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
